import {isNumber, isEmpty, isString, isObject} from 'lodash/lang';
import LocalStorage from './localStorage';
import {COUNTRY_VERSION} from '../configs';

export function getCountryCodeById(countryId) {
  const data = LocalStorage.countries.data;

  const countries = countryArrayParserToObject(data, COUNTRY_VERSION);

  if (!isNumber(countryId) && isEmpty(countryId)) countryId = '1'; // Set US as default.
  if (!isString(countryId)) countryId = countryId.toString();

  const country = (!!countries && countries[countryId]) || {};

  const {code} = country || {};
  return code;
}

export function getCountryNameById(countryId) {
  const data = LocalStorage.countries.data;

  const countries = countryArrayParserToObject(data, COUNTRY_VERSION);

  if (!isNumber(countryId) && isEmpty(countryId)) countryId = '1'; // Set US as default.
  if (isString(countryId)) countryId = countryId.toString();

  const country = (!!countries && countries[countryId]) || {};
  const {name} = country || {};
  return name;
}

export function getCountryNameByCode(code = 'US') {
  const data = LocalStorage.countries.data;
  const countriesObject = countryArrayParserToObject(data, COUNTRY_VERSION);
  const countriesArray = countryObjectParserToArray(countriesObject);

  // Set US as default
  const item = countriesArray.find(
    (item) => item.code === code || item.code_3 === code
  );

  return (item || '').name || code; // returns country name
}

export function getAddressByComponent(component = {}) {
  if (isEmpty(component) || !isObject(component)) return '';

  const {address, street, city, suburb, state, country, postcode} = component;

  let arr = [];

  if (address) {
    arr.push(address);
  } else {
    if (street) arr.push(street);
    if (city) arr.push(city);
    if (suburb) arr.push(suburb);
    if (state) arr.push(state);
    if (country) arr.push(country);
    if (postcode) arr.push(postcode);
  }

  return arr.join(', ');
}

export function countryArrayParserToObject(countries, version) {
  if ((isEmpty(countries) && !isObject(countries)) || !version) return {};

  const object = {};

  countries.forEach((country) => {
    if (version && country.version === version) {
      object[country.countries_id] = country;
    }
  });

  return object;
}

export function countryObjectParserToArray(countries) {
  if (isEmpty(countries)) return [];

  const array = Object.values(countries);

  return array;
}
